import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "action-btn relative" }
const _hoisted_2 = ["onClick"]

import { ISelectOption } from '@/types/interfaces/common.interface'
import { useToggle, onClickOutside } from '@vueuse/core'
import { PropType, ref } from 'vue'
import { CheckIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/24/solid'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceButtonOption',
  props: {
  value: {
    type: String,
    default: '',
  },
  isEnable: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array as PropType<ISelectOption[]>,
    default: () => [],
  },
},
  emits: ['change-device'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const [isOpen, toggle] = useToggle()

const containerRef = ref<HTMLElement>()
onClickOutside(containerRef, () => {
  toggle(false)
})

const select = (selectedValue: string) => {
  if (props.value === selectedValue) return
  emit('change-device', selectedValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "device-btn-container"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default"),
      _withDirectives(_createElementVNode("div", {
        class: "arrow-box",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggle)(!_unref(isOpen))))
      }, [
        (_unref(isOpen))
          ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
              key: 0,
              class: "w-3 h-3"
            }))
          : (_openBlock(), _createBlock(_unref(ChevronUpIcon), {
              key: 1,
              class: "w-3 h-3"
            }))
      ], 512), [
        [_vShow, __props.options.length]
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["options", _unref(isOpen) ? 'active' : ''])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `opt-${index}`,
          class: "option",
          onClick: ($event: any) => (select(option.value))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["option-label", { selected: __props.value === option.value }])
          }, [
            (__props.value === option.value)
              ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                  key: 0,
                  "aria-hidden": "true",
                  class: "w-4 h-4 mt-1"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, _toDisplayString(option.label), 1)
          ], 2)
        ], 8, _hoisted_2))
      }), 128))
    ], 2)
  ], 512))
}
}

})